export default __webpack_public_path__ + "assets/logo.76cb7129.png";